import React from "react";

type DateProps = { date?: string };

const { format } = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium"
});

const FormattedDate: React.FC<DateProps> = ({ date }) => {
  if (!date) return null;
  const formattedDate = format(new Date(date + "T00:00:00"));

  return <time dateTime={date}>{formattedDate}</time>;
};

export default FormattedDate;
